export default __webpack_public_path__ + "f94e79c3ed4e2a89d7a7d21f09c65aa6.svg";